import type { GetThemedStylesByKey } from '@/styles/types/utils';
import type { TextColor } from './types';
import styled from '@mui/material/styles/styled';
import AlertIcon from '@/assets/icons/alert.svg?react';
import CheckIcon from '@/assets/icons/check.svg?react';
import CircleIcon from '@/assets/icons/circle.svg?react';
import { Button } from '@/components/ui/buttons/Button/Button';

const getTextStylesByColor: GetThemedStylesByKey<TextColor> = ({ palette }) => ({
  default: {
    color: palette.text.greyDark,
  },
  green: {
    color: palette.text.greenLight,
  },
});

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 1.94rem;

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 1.25rem;
  }
`;

export const Title = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Options = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AdaptiveButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 2.5rem;
  }
`;

export const ValidationRules = styled('div')`
  display: flex;
  background-color: ${({ theme }) => theme.palette.background.primary};
  padding: 0.875rem 1rem;
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 4px;
  gap: 0.4375rem;
`;

export const List = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const Text = styled('div')<{ applied: boolean }>(({ applied, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  marginBottom: '0.25rem',
  ...theme.typography.caption,
  ...getTextStylesByColor(theme)[applied ? 'green' : 'default'],
}));

export const LockIcon = styled(AlertIcon)(({ theme }) => ({
  color: theme.palette.icon.vectorAdaptiveSecondaryLight,
}));

export const RuleFailIcon = styled(CircleIcon)(({ theme }) => ({
  color: theme.palette.icon.vectorAdaptiveGrey,
}));

export const RuleSuccessIcon = styled(CheckIcon)(({ theme }) => ({
  color: theme.palette.icon.vectorAdaptiveGreenLight,
}));
